import {
    CREATE_BUSINESS_MANAGEMENT,
    CREATE_BUSINESS_MANAGEMENT_FAILURE,
    CREATE_BUSINESS_MANAGEMENT_SUCCESS,
    EMPTY_FETCH_BUSINESS_MANAGEMENT_WITHOUT_PAGINATION,
    EXPORT_BUSINESS_MANAGEMENT,
    EXPORT_BUSINESS_MANAGEMENT_SUCCESS,
    FETCH_ALL_BUSINESS_MANAGEMENT,
    FETCH_ALL_BUSINESS_MANAGEMENT_SUCCESS,
    FETCH_BUSINESS_MANAGEMENT_BY_ID,
    FETCH_BUSINESS_MANAGEMENT_BY_ID_SUCCESS,
    FETCH_BUSINESS_MANAGEMENT_WITHOUT_PAGINATION,
    FETCH_BUSINESS_MANAGEMENT_WITHOUT_PAGINATION_SUCCESS,
    FETCH_TOTAL_BUSINESS_MANAGEMENT,
    FETCH_TOTAL_BUSINESS_MANAGEMENT_SUCCESS,
    RESTORE_BUSINESS_INITIAL,
    UPDATE_BUSINESS_MANAGEMENT,
    UPDATE_BUSINESS_MANAGEMENT_SUCCESS,
    UPDATE_BUSINESS_MANAGEMENT_FAILURE,
} from "../ActionTypes"



// To add new skill set
export const addBusinessManagement = (payload) => ({  
    type: CREATE_BUSINESS_MANAGEMENT,
    payload
    
});

export const addBusinessManagementSuccess = payload => ({
    type: CREATE_BUSINESS_MANAGEMENT_SUCCESS,
    payload
});

export const addBusinessManagementFailure = payload => ({
    type: CREATE_BUSINESS_MANAGEMENT_FAILURE,
    payload
});

// To fetch all business mgt
export const fetchBusinessManagement = (payload) => ({
    type: FETCH_ALL_BUSINESS_MANAGEMENT,
    payload
});

export const fetchBusinessManagementSuccess = (payload) => ({
    type: FETCH_ALL_BUSINESS_MANAGEMENT_SUCCESS,
    payload
});


// To export all business mgt as csv
export const exportBusinessManagement = () =>({
    type: EXPORT_BUSINESS_MANAGEMENT
})

export const exportBusinessManagementSuccess = payload =>({
    type: EXPORT_BUSINESS_MANAGEMENT_SUCCESS,
    payload
})

// to restore business
export const restoreBusinessInitial = () => ({
    type: RESTORE_BUSINESS_INITIAL
});

// To update business mgt
export const updateBusinessManagement = (payload) =>({
    type: UPDATE_BUSINESS_MANAGEMENT,
    payload
})
export const updateBusinessManagementSuccess = (payload) =>({
    type: UPDATE_BUSINESS_MANAGEMENT_SUCCESS,
    payload
})

export const updateBusinessManagementFailure = payload => ({
  type: UPDATE_BUSINESS_MANAGEMENT_FAILURE,
  payload
})

export const fetchBusinessManagementWithoutPagination = () =>({
    type:FETCH_BUSINESS_MANAGEMENT_WITHOUT_PAGINATION
})

export const fetchBusinessManagementWithoutPaginationSuccess = (payload) =>({
    type:FETCH_BUSINESS_MANAGEMENT_WITHOUT_PAGINATION_SUCCESS,
    payload
})

export const emptyFetchBusinessMgtNoPagination = () =>({
    type:EMPTY_FETCH_BUSINESS_MANAGEMENT_WITHOUT_PAGINATION,

})

export const fetchTotalBusinessManagement = () =>({
    type:FETCH_TOTAL_BUSINESS_MANAGEMENT
})

export const fetchTotalBusinessManagementSuccess = (payload) =>({
    type:FETCH_TOTAL_BUSINESS_MANAGEMENT_SUCCESS,
    payload
})


// To fetch all business mgt
export const fetchBusinessManagementById = (payload) => ({
    type: FETCH_BUSINESS_MANAGEMENT_BY_ID,
    payload
});

export const fetchBusinessManagementByIdSuccess = (payload) => ({
    type: FETCH_BUSINESS_MANAGEMENT_BY_ID_SUCCESS,
    payload
});
